import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import DashboardPage from '../pages/DashboardPage';
import CollaborateurDashboardPage from '../pages/CollaborateurDashboardPage';
import { isCollaborateurUser } from '../utils/roles';

const DashboardRouter: React.FC = () => {
  const { user } = useAuth();
  return isCollaborateurUser(user) ? <CollaborateurDashboardPage /> : <DashboardPage />;
};

export default DashboardRouter;
